import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from 'components/ui/Accordion';
import { SectionLabel } from 'components/ui/SectionLabel';
import { useLanguage } from 'context/language.context';
import { StringKey } from 'dictionaries/string-key.enum';
import { cn } from 'lib/utils';
import { motion } from 'motion/react';

export const FAQsSection = () => {
  const { t, direction } = useLanguage();

  const accordionContent = [
    {
      title: t(StringKey.FAQ_1_TITLE),
      description: t(StringKey.FAQ_1_DESC),
    },
    {
      title: t(StringKey.FAQ_2_TITLE),
      description: t(StringKey.FAQ_2_DESC),
    },
    {
      title: t(StringKey.FAQ_3_TITLE),
      description: t(StringKey.FAQ_3_DESC),
    },
    {
      title: t(StringKey.FAQ_4_TITLE),
      description: t(StringKey.FAQ_4_DESC),
    },
    {
      title: t(StringKey.FAQ_5_TITLE),
      description: t(StringKey.FAQ_5_DESC),
    },
    {
      title: t(StringKey.FAQ_6_TITLE),
      description: t(StringKey.FAQ_6_DESC),
    },
  ];

  return (
    <section
      id="faqs"
      className="relative w-full overflow-x-hidden flex flex-col items-center bg-[#08070C] px-4 md:px-20 py-[80px] md:py-[150px]"
    >
      <div className="flex flex-col items-start md:items-center">
        <SectionLabel>{t(StringKey.FAQ_LABEL)}</SectionLabel>
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ ease: 'easeOut', duration: 0.6, delay: 0 }}
        >
          <h3 className="bg-clip-text bg-label-gradient mt-2 font-semibold text-[30px] leading-[38px] md:text-4xl text-transparent text-start md:text-center">
            {t(StringKey.FREQUENTLY_ASKED_QUESTIONS)}
          </h3>
        </motion.div>
      </div>
      <motion.div
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ ease: 'easeOut', duration: 0.6, delay: 0 }}
        className="mt-11 md:mt-16 w-full max-w-full md:w-[80%] md:max-w-[80%] lg:w-[63%] lg:max-w-[63%]"
      >
        {accordionContent.map(({ title, description }, index) => (
          <Accordion key={index} type="single" collapsible>
            <AccordionItem
              className={cn(index === accordionContent.length - 1 && 'border-b-0')}
              value="1"
            >
              <AccordionTrigger className="gap-6">
                <p className="text-start text-m leading-6 md:text-xl md:leading-[30px]">{title}</p>
              </AccordionTrigger>
              <AccordionContent
                className={cn(direction === 'rtl' ? 'ml-8 md:ml-14' : 'mr-8 md:mr-14')}
              >
                <p>{description}</p>
              </AccordionContent>
            </AccordionItem>
          </Accordion>
        ))}
      </motion.div>
    </section>
  );
};
